import React, { FC, useEffect, useRef, useState } from 'react'
import { Column } from 'react-table'
import Table from '../../components/Table'
import { Button, Container, FormControl, Grid, InputLabel, makeStyles, MenuItem, Select, TextField, Typography } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import DateFnsUtils from '@date-io/date-fns'
import { MuiPickersUtilsProvider, KeyboardDatePicker, KeyboardTimePicker } from '@material-ui/pickers'
import * as StatsAPI from '../../api/statistics/statistics'
import * as StatsModels from '../../api/statistics/models'
import * as ShortAPI from '../../api/short/index'
import * as ShortModels from '../../api/short/models'
import { AccessTime } from '@material-ui/icons'
import moment from "moment"
import "moment/locale/da"
import daLocale from "date-fns/locale/da"
import NoDataDialog from '../../components/dialogs/ErrorDialog'
import APIRequest from '../../components/helpers/APIRequest'
import * as CSV from '../../utils/exportcsv'
import LoadingSymbols from '../../utils/loadingSymbol'
import * as mobilbase from '../../api/mobilbase';
import AlignedCell from '../../components/layout//AlignedCell';
import AlignedHeader from '../../components/layout/AlignedHeader'
moment.locale("da")

const useStyles = makeStyles((theme) => ({
    paper: {
        [theme.breakpoints.up('sm')]: {
            padding: '0',
        },
        marginTop: theme.spacing(3),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    buts: {
        width: '100%',
        height: '100%'
    },
    autoForm:{
        width: '100%',
        height: '100%',
        marginTop: '1rem'
    },
    grid: {
        width: '100%', // Fix IE 11 issue.
        marginTop: theme.spacing(3),
    },
    textHelp: {
        marginBottom: '1rem'
    },
    margTop: {
        marginTop: theme.spacing(2),
    }
}))

const EmptyingStatistics: FC = () => {
    const classes = useStyles()

    const [currentLocation, setCurrentLocation] = useState(-1)
    const [locations, setLocations] = useState<ShortModels.Location[]>([])
    const [isPendingLocations, setIsPendingLocations] = useState(false)
    const [runLocations, setRunLocations] = useState(true)

    const [devices, setDevices] = useState<StatsModels.DeviceListResponse>(new StatsModels.DeviceListResponse())
    const [isPendingDevices, setIsPendingDevices] = useState(false)
    const [runGetDevices, setRunGetDevices] = useState(false)

    const [emptyingData, setEmptyingData] = useState<StatsModels.EmptyingResponse>({version: "", id: "", result: []})
    const [isPending, setIsPending] = useState(false)
    const [run, setRun] = useState(false)
    const [showError, setShowError] = useState(false)
    const [fromDate, setFromDate] = useState<Date | null>(new Date())
    const [toDate, setToDate] = useState<Date | null>(new Date())
    const [fromTime, setFromTime] = useState<Date | null>(new Date(0, 0, 0, 0, 0, 0, 0))
    const [toTime, setToTime] = useState<Date | null>(new Date(0, 0, 0, 23, 59, 0, 0))
    const [timeRange, setTimeRange] = useState(false)
    const [fetchData, setFetchData] = useState(false)
    const [downloadData, setDownloadData] = useState(false)
    const [pendingLoadingPicture, setPendingLoadingPicture] = useState(false)


    const [selectedDevices, setSelectedDevices] = useState<StatsModels.DeviceData[]>([])

    const labelLocationRef = useRef(null)
    // @ts-ignore: Object is possibly 'null'
    const labelLocationWidth = (labelLocationRef !== null && labelLocationRef.current !== null) ? labelLocationRef.current.clientWidth : 0

    var keyList = [""]

    useEffect(() => {
        function handleKeyDown(event: any){
            const keyname = event.key
            keyList.push(keyname)
    
            if (event.shiftKey && keyList.includes("S") && keyList.includes("E")) {
                setDownloadData(true)
            }
            if (event.shiftKey && keyList.includes("S") && keyList.includes("H") ) {
                setFetchData(true)
            }
        }
        document.addEventListener("keydown", handleKeyDown)

        return function cleanUP() {
            document.removeEventListener("keydown", handleKeyDown)
        }
    })
    
    useEffect(() => {
        function handleKeyUp(event: any){
            keyList = [""]
            setDownloadData(false)
            setFetchData(false)
        }
        document.addEventListener("keyup", handleKeyUp)

        return function cleanUP() {
            document.removeEventListener("keyup", handleKeyUp)
        }
    })

    useEffect( () => {
        if (downloadData){
            downloadCSV()
        }
    }, [downloadData])

    useEffect( () => {
        if (fetchData){
            return setRun(true)
        }
    }, [fetchData])
    
    useEffect(() => {
        if (locations.length > 0 && currentLocation === -1) {
            setCurrentLocation(locations[0].id)
        }
    }, [locations, currentLocation])

    useEffect(() => {
        if (currentLocation > 0) {
            setRunGetDevices(true)
        }
    }, [currentLocation])
    
    useEffect(() => {  // show data fetching loading picture
        if (!isPending){
            setPendingLoadingPicture(false)
        }
        else{
            setPendingLoadingPicture(true)
        }
    }, [isPending])

    const columnsEmptyingReport: Column<StatsModels.EmptyingData>[] = React.useMemo(() => [
        {Header: "Automat", id: "0", accessor: "deviceName"}, 
        {Header:()=><AlignedHeader value="Tømningsnr." justify='flex-end' alignT='right'/> , id: "1", accessor: "emptyNr", Cell: ({ value }: { value: string }) => <AlignedCell value={value} />}, 
        {Header: "Tidspunkt", id: "2", accessor: "emptyTimeString", sortType: compareDateString},
        {Header:()=><AlignedHeader value="Værdi 1 kr" justify='flex-end' alignT='right'/> , id: "3", accessor: "valueDk001", sortType: compareNumericString, Cell: ({ value }: { value: string }) => <AlignedCell value={value} />}, 
        {Header:()=><AlignedHeader value="Antal 1 kr" justify='flex-end' alignT='right'/> , id: "4", accessor: "countDk001", Cell: ({ value }: { value: string }) => <AlignedCell value={value} />}, 
        {Header:()=><AlignedHeader value="Værdi 2 kr" justify='flex-end' alignT='right'/> , id: "5", accessor: "valueDk002", sortType: compareNumericString, Cell: ({ value }: { value: string }) => <AlignedCell value={value} />}, 
        {Header:()=><AlignedHeader value="Antal 2 kr" justify='flex-end' alignT='right'/> , id: "6", accessor: "countDk002", Cell: ({ value }: { value: string }) => <AlignedCell value={value} />},
        {Header:()=><AlignedHeader value="Værdi 5 kr" justify='flex-end' alignT='right'/> , id: "7", accessor: "valueDk005", sortType: compareNumericString, Cell: ({ value }: { value: string }) => <AlignedCell value={value} />}, 
        {Header:()=><AlignedHeader value="Antal 5 kr" justify='flex-end' alignT='right'/> , id: "8", accessor: "countDk005", Cell: ({ value }: { value: string }) => <AlignedCell value={value} />}, 
        {Header:()=><AlignedHeader value="Værdi 10 kr" justify='flex-end' alignT='right'/> , id: "9", accessor: "valueDk010", sortType: compareNumericString, Cell: ({ value }: { value: string }) => <AlignedCell value={value} />}, 
        {Header:()=><AlignedHeader value="Antal 10 kr" justify='flex-end' alignT='right'/> , id: "10", accessor: "countDk010", Cell: ({ value }: { value: string }) => <AlignedCell value={value} />},
        {Header:()=><AlignedHeader value="Værdi 20 kr" justify='flex-end' alignT='right'/> , id: "11", accessor: "valueDk020", sortType: compareNumericString, Cell: ({ value }: { value: string }) => <AlignedCell value={value} />}, 
        {Header:()=><AlignedHeader value="Antal 20 kr" justify='flex-end' alignT='right'/> , id: "12", accessor: "countDk020", Cell: ({ value }: { value: string }) => <AlignedCell value={value} />}, 
        {Header:()=><AlignedHeader value="Beløb" justify='flex-end' alignT='right'/> , id: "13", accessor: "amount", sortType: compareNumericString, Cell: ({ value }: { value: string }) => <AlignedCell value={value} />}, 
        {Header:()=><AlignedHeader value="Akkumuleret sum" justify='flex-end' alignT='right'/> , id: "14", accessor: "valueTotal", sortType: compareNumericString, Cell: ({ value }: { value: string }) => <AlignedCell value={value} />}
    ], [])

    const RequestData = () => {
        const fixDate = (date: Date | null, startOfDay: boolean) => {
            // We have to send the date with a UTC timezone, or the server will get the value wrong
            var d1 = date ? date : new Date()
            if(startOfDay)
            var d = new Date(Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate(), 0, 0, 0, 0))
            else var d = new Date(Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate(), 23, 59,59, 0))
            return d
        }
        const param = (): StatsModels.Params => {
            // Choose all devices if none are chosen
            var meters = selectedDevices.length < 1 ? devices.result : selectedDevices;
            return {location: currentLocation, body: {Start: fixDate(fromDate, true), End: fixDate(toDate, false), Meters: meters.map((d) => d.id)}}
        }
        return (<APIRequest<StatsModels.EmptyingResponse>
            run={run} setRun={setRun}
            pending={isPending} setIsPending={setIsPending}
            req={() => StatsAPI.getEmptyingReport(param())}
            setData={setEmptyingData}
            setShowError={setShowError}
        />)
    }

    function compareNumericString(rowA: any, rowB: any, id: any, desc: any) {
        let a = parseFloat(rowA.values[id].replace(".", ""))
        let b = parseFloat(rowB.values[id].replace(".", ""))

        if (rowA.values[0] === "Total") {  // find total row, and put it last or first
            a = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
        }
        if (rowB.values[0] === "Total") {
            b = desc ? Number.NEGATIVE_INFINITY : Number.POSITIVE_INFINITY;
        }
        if (a > b) return 1; 
        if (a < b) return -1;
        return 0;
    }

    function compareDateString(rowA: any, rowB: any) {
        let a = rowA.original.emptyTime 
        let b = rowB.original.emptyTime

        if (a > b) return 1; 
        if (a < b) return -1;
        return 0;
    }

    const RequestLocationsData = () => {
        return (<APIRequest<ShortModels.Location[]>
            run={runLocations} setRun={setRunLocations}
            pending={isPendingLocations} setIsPending={setIsPendingLocations}
            req={ShortAPI.getLocations}
            setData={setLocations}
        />)
    }

    const RequestDevices = () => {
        return (<APIRequest<StatsModels.DeviceListResponse>
            run={runGetDevices} setRun={setRunGetDevices}
            pending={isPendingDevices} setIsPending={setIsPendingDevices}
            req={() => StatsAPI.getDeviceList(currentLocation)}
            setData={setDevices}
        />)
    }

    const setDevicesSelection = (newSelection: ShortModels.Device[] | null) => {
        if (newSelection) {
            setSelectedDevices(newSelection)
        } else {
            setSelectedDevices([])
        }
    }


    const XlsxParam =():StatsModels.ParamsXlsx =>{
        var d1 = fromDate ? fromDate : new Date()
        let start:Date = new Date(Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate(), 0, 0, 0, 0))

        var d1 = toDate ? toDate : new Date()
        let end:Date = new Date(Date.UTC(d1.getFullYear(), d1.getMonth(), d1.getDate(), 23, 59, 59, 0))
        var meters = selectedDevices.length < 1 ? devices.result : selectedDevices;
        let mett: number[] = meters.map((d) => d.id)

        return {
            location:currentLocation,
            body:{
                Start: start,
                End: end,
                Meters: mett,
                Columns1:columnsEmptyingReport,
            }
        }

    }

    const downloadCSV = async () => {
        //let headers: string[] = columnsEmptyingReport.map(column => {return "" + column.Header})
        //let keys: string[] = columnsEmptyingReport.map(column => {return "" + column.accessor})
        //CSV.exportCSVFromObjects("tømning.csv", headers, keys, emptyingData.result, [], [2])
        setPendingLoadingPicture(true) // start loading symbol
        await mobilbase.requestXlsx("tømning.xlsx",'emptying',XlsxParam())
        .then((res) => {
            setPendingLoadingPicture(false) // ends loading symbol
        })
        .catch((err) =>{
            setPendingLoadingPicture(false) // end loading symbol
            setShowError(true) // if something fails, start error message
        })    
    }

    function updateLocValue(val: any){ // the method that the currentlocation gets updated from the Autocomplete
        let updatedLocValue = val?.id
        setSelectedDevices([]) // clears the selected devices

        if (updatedLocValue === null){
            return false
        }
        else{
        setCurrentLocation(updatedLocValue)
        return true
        }
    }

    return (
        <Container maxWidth={false}>
            <LoadingSymbols pendingLoadingPicture={pendingLoadingPicture} setPendingLoadingPicture={pendingLoadingPicture} open={pendingLoadingPicture} loadingSymbolText={"Henter data, vent venligst..."} />
            <RequestData />
            <RequestLocationsData />
            <RequestDevices />
            <div className={classes.paper}>
                <Typography component="h1" variant="h5">Mønttømning</Typography>

                <Container maxWidth={"lg"} className={classes.margTop}>
                    <MuiPickersUtilsProvider locale={daLocale} utils={DateFnsUtils}>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                            <FormControl variant="outlined" fullWidth margin="normal">
                                    <InputLabel ref={labelLocationRef} shrink htmlFor="emptying-location"></InputLabel>
                                    <Autocomplete id="id" options={locations} getOptionLabel={option => option.name} onChange={(event, value) => updateLocValue(value)} renderInput={params => ( <TextField {...params} label="Pladser" variant="outlined" />  )}/>
                                </FormControl>
                            </Grid>
                            <Grid item xs={6}>
                                <Autocomplete className={classes.autoForm} multiple value={selectedDevices} options={devices.result} getOptionLabel={option => option.name}
                                    renderInput={params => (<TextField {...params} label={selectedDevices.length === 0 ? "Automater - alle valgt" : "Automater"} variant="outlined" fullWidth />)}
                                    onChange={(event: any, newSelection: ShortModels.Device[] | null) => setDevicesSelection(newSelection)} />
                            </Grid>
                            <Grid item xs={8}> </Grid>
                            <Grid item xs={6}>
                                <KeyboardDatePicker fullWidth disableToolbar variant="inline" inputVariant="outlined" format="dd-MM-yyyy" margin="normal" id="date-picker-inline" label="Fra" value={fromDate} onChange={setFromDate} KeyboardButtonProps={{'aria-label': 'Set dato'}} />
                            </Grid>
                            <Grid item xs={6}>
                                <KeyboardDatePicker fullWidth disableToolbar variant="inline" inputVariant="outlined" format="dd-MM-yyyy" margin="normal" id="date-picker-inline" label="Til" value={toDate} onChange={setToDate} KeyboardButtonProps={{'aria-label': 'Set dato'}} />
                            </Grid>
                            <Grid item xs={8}> </Grid>
                            <Grid item xs={5}>
                                <Button variant="contained" color="primary" className={classes.buts} onClick={() => setRun(true)}>Hent</Button>
                            </Grid>
                            <Grid item xs={5}>
                                <Button disabled={emptyingData.result.length < 1} variant="contained" color="primary" className={classes.buts} onClick={downloadCSV}>Eksportér</Button>
                            </Grid>
                        </Grid>
                    </MuiPickersUtilsProvider>
                </Container>

                <div className={classes.grid}>
                    <Table<StatsModels.EmptyingData> columns={columnsEmptyingReport} data={emptyingData.result} initialState={{pageSize: 150}} clickEvent={() => {}} update={null} pending={false} text={""}/>
                </div>
            </div>

            <NoDataDialog open={showError} onClose={() => { setShowError(false) }} title={"Intet svar"} text={"Noget gik galt, prøv venligst igen senere."}/>
        </Container>
    )
}

export default EmptyingStatistics
